<template>
  <div class="contentMain">
    <div class="content">
      <!-- 列表 -->
      <div class="listMain" v-if="contentType == 'list'">
        <div class="contentPart">
          <div class="leftPart">
            <div class="typeText">{{ typeName }}</div>
            <div>
              <div
                v-for="(item, index) in firList"
                :key="index"
                class="leftItem"
                :class="index == firSelect ? 'active' : ''"
                @click="firListClick(index)"
              >
                {{ item.typeName }}
              </div>
            </div>
          </div>
          <div class="rightPart">
            <div class="listHeader">
              <div class="itemText" v-if="firList[firSelect]">
                {{ firList[firSelect].typeName }}
              </div>
              <div
                style="display:flex;align-items:center;line-height:50px;font-size:14px;"
              >
                <img
                  src="../../assets/position.png"
                  style="margin-right:10px"
                />
                <span style="cursor: pointer;" @click="firListClick(0)">{{
                  typeName
                }}</span>
                >>
                <span v-if="firList[firSelect]">{{
                  firList[firSelect].typeName
                }}</span>
              </div>
            </div>
            <!-- v-if="
                firList[firSelect] &&
                  (firList[firSelect].typeName != '文件下载' ||
                    firList[firSelect].typeName != '电子杂志')
              " -->
            <div
              class="rightList"
              style="cursor: pointer;"
              v-for="(item, index) in secList"
              @click="toDetail(item)"
            >
              <div class="text">{{ item.title }}</div>
              <div style="width:200px;text-align:right;" v-if="item.createTime">
                {{ item.createTime.slice(0, 10) }}
              </div>
            </div>
            <!-- <div
              class="rightList"
              style="cursor: pointer;"
              v-for="(item, index) in secList"
              v-else
              @click="downloadView(item)"
            >
              <div class="text">{{ item.title }}</div>
              <div style="width:200px;text-align:right;" v-if="item.createTime">
                {{ item.createTime.slice(0, 10) }}
              </div>
            </div> -->
            <div class="pagination">
              <el-pagination
                small
                layout="total, prev, pager, next, jumper"
                :current-page="pageNum"
                :total="totalNum"
                @current-change="pageChange"
                :page-size="15"
              ></el-pagination>
            </div>
          </div>
        </div>
      </div>
      <!-- 详情 -->
      <div class="detailMain" v-if="contentType == 'info'">
        <div style="display:flex;align-items:center;line-height:35px;font-size:14px;">
          <img src="../../assets/position.png" style="margin-right:10px" />
          <span
            style="cursor: pointer;"
            @click="firListClick(0), (contentType = 'list')"
            >{{ typeName }}</span
          >
          >>
          <span
            style="cursor: pointer;"
            @click="contentType = 'list'"
            v-if="firList[firSelect]"
            >{{ firList[firSelect].typeName }}</span
          >
          >>
          <span>文章阅读</span>
        </div>
        <div class="contentPart">
          <div ref="daying">
            <div class="contentTitle">{{ article.title }}</div>
            <div class="contentInfo">
              <span v-if="article.createTime"
                >发布日期：{{ article.createTime.slice(0, 10) }}</span
              >
              <span style="margin-left:20px;">发布者：系统管理员</span>
            </div>
            <div class="markDown" v-html="article.content"></div>
            <div v-if="article.url" class="attachment-section">
              <div class="attachment-title">附件下载</div>
              <div class="attachment-item">
                <i class="el-icon-document"></i>
                <span class="attachment-name">{{ getAttachmentName(article.url) }}</span>
                <div class="attachment-actions">
                  <el-button type="primary" size="small" icon="el-icon-view" @click="handlePreview">
                    预览
                  </el-button>
                  <el-button type="success" size="small" icon="el-icon-download" @click="handleDownload">
                    下载
                  </el-button>
                </div>
              </div>
            </div>
          </div>

          <div class="shareBox">
            <div class="leftPart">
              <i class="el-icon-share" style="margin: 0 10px"></i>
              <el-popover placement="top" trigger="hover">
                <div style="text-align:center;">
                  <div>微信扫一扫</div>
                  <div id="qrcode"></div>
                  <div><p>扫一扫分享至朋友圈</p></div>
                </div>
                <img
                  src="../../assets/share/weixin.png"
                  v-show="config.url != ''"
                  class="weixinPic"
                  slot="reference"
                />
              </el-popover>

              <share v-if="config.url != ''" :config="config"></share>
            </div>
            <div style="cursor: pointer;">
              <img src="../../assets/art_pic_01.png" alt="" @click="print" />
              <span style="margin: 0 10px" @click="print">打印</span>
              <img src="../../assets/art_pic_02.png" alt="" @click="close" />
              <span style="margin: 0 10px" @click="close">关闭</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { chileType, selArticleByType, getArticle } from "@/api/main";
import QRCode from "qrcodejs2";
export default {
  name: "Content",
  props: {
    tabsTypeName: String,
    tabsTypeId: String,
  },
  data() {
    return {
      contentType: "list",
      typeId: "",
      typeName: "",
      pageNum: 1,
      totalNum: 0,
      firList: [],
      firSelect: 0,
      secList: [],
      article: {},
      articleInfo: {},
      config: {
        url: "",
        sites: ["weibo", "qq", "qzone"],
        wechatQrcodeTitle: "微信扫一扫",
        wechatQrcodeHelper: "<p>扫一扫分享至朋友圈</p>",
      },
    };
  },
  mounted() {
    this.typeId = this.$route.query.typeId;
    this.typeName = this.$route.query.type;
    // if (this.$route.params.type) {
    //   this.typeId = this.$route.params.typeId;
    //   this.typeName = this.$route.params.type;
    // }
    this.getInfo();
    if (this.$route.query.articleId) {
      this.detail(this.$route.query.articleId);
    }
  },
  watch: {
    tabsTypeId: function(val) {
      if (val) {
        this.contentType = "list";
        this.typeId = val;
        this.pageNum = 1;
        this.getInfo();
      }
    },
    tabsTypeName: function(val) {
      if (val) {
        this.typeName = val;
      }
    },
    contentType: function(val) {
      if (val == "list") {
        document.title = this.typeName;
      }
    },
  },
  methods: {
    getAttachmentName(url) {
      if (!url) return '';
      const parts = url.split('/');
      return parts[parts.length - 1] || '附件';
    },
    handlePreview() {
      if (!this.article.url) return;

      const fileName = this.article.url.substring(this.article.url.lastIndexOf('.') + 1).toLowerCase();
      const previewFormats = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx'];
      const officeFormats = ['pdf'];

      if (previewFormats.includes(fileName)) {
        window.open(this.article.url, '_blank');
      } else if (officeFormats.includes(fileName)) {
        window.open(`/carec/pdfjs/build/generic/web/viewer.html?file=${encodeURIComponent(this.article.url)}`, '_blank');
      } else {
        this.$message.warning('该文件格式不支持在线预览，请下载后查看');
      }
    },
    handleDownload() {
      if (!this.article.url) return;

      const filename = this.getAttachmentName(this.article.url);

      // 使用 fetch 获取文件内容并触发下载
      fetch(this.article.url)
          .then(response => response.blob())
          .then(blob => {
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = filename;
            link.style.display = 'none';
            document.body.appendChild(link);
            link.click();

            // 清理
            setTimeout(() => {
              document.body.removeChild(link);
              window.URL.revokeObjectURL(url);
            }, 100);
          })
          .catch(error => {
            console.error('下载失败:', error);
            this.$message.error('下载失败，请稍后重试');
          });
    },
    close() {
      window.opener = null;
      window.open("", "_self");
      window.close();
    },
    qrcode() {
      document.getElementById("qrcode").innerHTML = ""; //清除上一次生成的二维码，防止刷新生成多个二维码
      this.config.url = "";
      var url = window.location.href;
      // targetUrl = "http://qr.liantu.com/api.php?text=" + encodePath;
      this.config.url = url;
      let qrcode = new QRCode("qrcode", {
        width: 160, //二维码宽度
        height: 160, //二维码高度
        text: url, // 二维码内容
        colorDark: "#000",
        colorLight: "#fff",
      });
    },
    getInfo() {
      var data = {
        typeId: this.typeId,
      };
      if (this.tabsTypeId) {
        data.typeId = this.$route.query.typeId;
      }
      chileType(data).then((resp) => {
        this.firList = resp.data;
        this.firListClick(0);
      });
    },
    firListClick(index) {
      this.firSelect = index;
      var data = {
        typeId: this.firList[index].id,
        page: this.pageNum - 1,
        size: 15,
      };
      selArticleByType(data).then((resp) => {
        this.totalNum = resp.data.totalElements;
        this.secList = resp.data.content;
      });
    },
    pageChange(num) {
      // console.log(num)
      this.pageNum = num;
      this.firListClick(this.firSelect);
    },
    print() {
      this.$print(this.$refs.daying);
    },
    toDetail(item) {
      const routeData = this.$router.resolve({
        query: {type: this.typeName, typeId: this.typeId, articleId: item.id},
      });
      if (item.content === 'true' || !item.url) {
        // 有内容就打开新页面展示
        window.open(routeData.href, '_blank');
      } else {
        // 没有内容看是否有附件有就打开
        const fileName = item.url.substring(item.url.lastIndexOf(".") + 1);
        if (['pdf'].includes(fileName)) {
          window.open(`/carec/pdfjs/build/generic/web/viewer.html?file=${encodeURIComponent(item.url)}`, '_blank');
        } else if(['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx'].includes(fileName)) {
          window.open(item.url);
        } else {
          window.open(routeData.href, '_blank');
        }
      }
      // this.detail(id);
    },
    detail(id) {
      getArticle({ id: id }).then((resp) => {
        this.article = resp.data;
        document.title = resp.data.title;
        this.checkedIndex(resp.data.type);
        this.qrcode();
      });
      this.contentType = "info";
    },
    checkedIndex(name) {
      var index = this.firList.findIndex((el) => el.id == name);
      console.log(name, index);
      if (index > -1) {
        this.firListClick(index);
      }
    },
    downloadView(item) {
      window.open(item.url);
    },
  },
};
</script>

<style>
/* 整体样式 */
.contentMain {
  width: 100%;
  padding-bottom: 20px;
  background-color: #fff;
  background: url("http://www.carec.org.cn/template/1/xh/_files/images/index_bg.jpg")
    no-repeat;
  background-size: cover;
  -webkit-background-size: cover;
  -o-background-size: cover;
  background-position: 100% 100%;
}
.contentMain .content {
  width: 1200px;
  background: #fff;
  margin: 0 auto;
  padding: 20px;
}

/* 详情 */
.detailMain .contentPart {
  width: 960px;
  margin: 0 auto;
}
.detailMain .contentPart .contentTitle {
  font-size: 30px;
  color: #333333;
  line-height: 1.8;
  text-align: center;
  font-weight: bold;
  padding-bottom: 20px;
  border-bottom: 1px solid #b7b7b7;
}
.detailMain .contentPart .markDown {
  min-height: 460px;
}
.detailMain .contentPart .markDown img {
  max-width: 100%;
}
.detailMain .contentPart .contentInfo {
  line-height: 50px;
  font-size: 15px;
  color: #999999;
  text-align: center;
}
/* table 样式 */
.detailMain .contentPart .markDown table {
  border-top: 1px solid #ccc;
  border-left: 1px solid #ccc;
}
.detailMain .contentPart .markDown table td,
.detailMain .contentPart .markDown table th {
  border-bottom: 1px solid #ccc;
  border-right: 0.5px solid #ccc;
  padding: 3px 5px;
}
.detailMain .contentPart .markDown table th {
  border-bottom: 2px solid #ccc;
  text-align: center;
}
.detailMain .contentPart .attachment-section {
  margin-top: 30px;
  padding: 20px;
  background: #f5f7fa;
  border-radius: 4px;
}
.detailMain .contentPart .attachment-section .attachment-title {
  font-size: 16px;
  font-weight: bold;
  color: #333;
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 1px solid #e4e7ed;
}
.detailMain .contentPart .attachment-section .attachment-item {
  display: flex;
  align-items: center;
  padding: 15px;
  background: #fff;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  transition: all 0.3s;
}
.detailMain .contentPart .attachment-section .attachment-item:hover {
  background: #f9fafc;
  border-color: #c0c4cc;
}
.detailMain .contentPart .attachment-section .attachment-item i.el-icon-document {
  font-size: 24px;
  color: #409eff;
  margin-right: 12px;
}
.detailMain .contentPart .attachment-section .attachment-item .attachment-name {
  flex: 1;
  color: #606266;
  font-size: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-right: 15px;
}
.detailMain .contentPart .attachment-section .attachment-item .attachment-actions {
  display: flex;
  gap: 10px;
  flex-shrink: 0;
}

.detailMain .contentPart .shareBox {
  line-height: 40px;
  height: 40px;
  margin: 20px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #f1f1f1;
}
.detailMain .contentPart .shareBox div {
  display: flex;
  align-items: center;
}
.detailMain .contentPart .shareBox .leftPart .weixinPic {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  padding: 5px;
  border: 1px solid #09bb07;
  margin: 0 5px -11px;
  cursor: pointer;
}

/* 列表 */
.listMain {
  min-height: 800px;
}
.listMain .contentPart {
  display: flex;
  justify-content: space-between;
}
.listMain .contentPart .leftPart {
  width: 243px;
}
.listMain .contentPart .leftPart .typeText {
  font-size: 24px;
  line-height: 50px;
  height: 50px;
  font-weight: bold;
  color: #165d9c;
}
.listMain .contentPart .leftPart .leftItem {
  cursor: pointer;
  width: 100%;
  font-size: 16px;
  line-height: 56px;
  height: 56px;
  border-bottom: 1px solid #e6e6e6;
  border-right: 1px solid #e6e6e6;
  border-left: 6px solid #fff;
  padding-left: 14px;
}
.listMain .contentPart .leftPart .leftItem:nth-child(1) {
  border-top: 1px solid #e6e6e6;
}
.listMain .contentPart .leftPart .leftItem:hover {
  background: #e6e6e6;
  color: #165d9c;
  border-left: 6px solid #165d9c;
}
.listMain .contentPart .leftPart .active {
  background: #e6e6e6;
  color: #165d9c;
  border-left: 6px solid #165d9c;
}
.listMain .contentPart .rightPart {
  width: 910px;
  padding-left: 20px;
  position: relative;
}
.listMain .contentPart .rightPart .listHeader {
  display: flex;
  align-items: center;
  border-bottom: 1px solid #dcdcdc;
  justify-content: space-between;
}
.listMain .contentPart .rightPart .listHeader .itemText {
  font-size: 24px;
  line-height: 50px;
  height: 50px;
  font-weight: bold;
}
.listMain .contentPart .rightPart .rightList {
  display: flex;
  align-items: center;
  justify-content: space-between;
  line-height: 44px;
  padding-left: 13px;
  border-bottom: 1px dashed #dddddd;
}
.listMain .contentPart .rightPart .rightList .text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.listMain .contentPart .rightPart .pagination {
  width: 100%;
  margin-top: 30px;
  text-align: center;
}
</style>
